const dataLayer = function ({ spaces }) {
  if (spaces) {
    spaces = Object.values(spaces);
    if (!window) return;
    window.dataLayer.push({
      event: "venueResultsList",
      venueList: spaces.map((space) => {
        return {
          name: space.venue_name,
          spaceName: space.name,
          description: space.description,
          url: space.url,
          id: space.oid,
          venue: space.venue_id,
          spaceHash: space.hashcode,
          venueHash: space.venue_hashcode,
        };
      }),
    });
  }
};
export { dataLayer };
export default dataLayer;
